import carrierConf from 'data/carrier-conf';
import NewAccount from './NewAccount';

const NewCarrierAccount = ({ carrierId }) => (
    <NewAccount title={carrierConf[carrierId]?.title} carrier={carrierConf[carrierId]} />
);

export default NewCarrierAccount;
